import { Component, OnDestroy, OnInit } from '@angular/core';
import { OAuthEvent, OAuthService, UserInfo } from 'angular-oauth2-oidc';
import { Contact } from './models/contact.model';
import { StorageService } from './core/services/storage/storage.service';
import { C1UserInfo } from './models/c1UserInfo.model';
import { GS1HeaderService, GS1LoadingService, HeaderAlert } from '@gs1france/gs1-components-library';
import { MaintenanceMessageService } from './core/services/maintenance-message/maintenance-message.service';
import {GoogleMapService} from "./core/services/map/googlemap.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'gs1-common-app';
  connectedUser = false;
  user?: Contact;
  c1User?: C1UserInfo;
  canChangeCompany = false;

  constructor(private authService: OAuthService,
              private storageService: StorageService,
              private _loader: GS1LoadingService,
              private maintenanceMessageService: MaintenanceMessageService,
              private _header: GS1HeaderService,
              private googleMapService: GoogleMapService
  ) {}

  ngOnInit(): void {
      this.loadInfo();
      this.getMaintenanceMessage();
      this.googleMapService.load();
      this.authService.events.subscribe((event: OAuthEvent) => {
        if (event.type === 'silently_refreshed' || event.type === 'session_changed') {
          this.loadInfo();
        }
      });
  }

  async getMaintenanceMessage() {
    const message =  await this.maintenanceMessageService.getMaintenanceMessage();
     if(message && message.message)
    {
     this._header.addAlert(new HeaderAlert(message.theme, message.message));
    }
 }

  /**
   * Loads the user's info and sets the user's contact.
   * @returns None
   */
  async loadInfo() {
    if (this.authService.hasValidAccessToken()) {
      this.connectedUser = true;
      this.authService.loadUserProfile().then((value: any) => {
        this.c1User = value.info as C1UserInfo;
        this.storageService.handleConnect1Infos(this.c1User);
        this.canChangeCompany = this.shouldShowCompanyChange();

      });
      if (!this.user)
        this.user = await this.storageService.getContact();
    } else {
      this.connectedUser = false;
    }
  }

  /**
   * Gets the user's full name.
   * @returns {string} The user's name.
   */
  getUserName() {
    return this.user?.firstName?.slice(0, 10) + (this.user?.firstName && this.user?.firstName?.length > 10 ? '. ' : ' ') + this.user?.lastName?.charAt(0) + '.';
  }

  /**
   * Logs the user out of the application.
   * @returns None
   */
  logout() {
    this.authService.logOut();
  }

  /**
   * Resets the current search to undefined.
   * @returns None
   */
  resetSearch() {
    this.storageService.setCurrentSearch(undefined);
  }

  forceAccountRefresh() {
    this.storageService.forceGLNRefresh = true;
    this.storageService.resetAccountPage();
  }

  changeCompany() {
    this._loader.startLoading('company-change')
    try {
      this.authService.customQueryParams = {
        'companies': true,
        'prompt':'login'
      }
      this.authService.resetImplicitFlow();
      this.authService.initImplicitFlow();
    } catch {
      this._loader.startLoading('company-change')
    }
  }

  shouldShowCompanyChange() {
    try {
      return !!this.c1User && !!this.c1User.companies_nb && Number(this.c1User.companies_nb) > 1
    } catch {
      return false
    }
  }
}
